module.exports = __webpack_public_path__ + "static/super-admin-category-list-2864836602285a073feaffdac301a3f6.png";